const STEPS = {
    CUSTOMER_INFO: 1,
    PAYMENT: 2,
    PLACE_ORDER: 3
}

const FX_TICKET_STOCK_TYPES = {
    ELECTRONIC: 'electronic',
    HARD: 'hard',
    PAPERLESS: 'paperless',
    MOBILE: 'mobile',
    FLASH: 'flash',
    INSTANT: 'instant',
}


const VS_TICKET_STOCK_TYPES = {
    // The values of this object match the API stock-type strings.
    E_TICKETS: "e-tickets",
    HARD: "hard",
    PAPERLESS_CARD: "paperless card",
    MOBILE_SCREENCAP: "mobile screencap",
    FLASH: "flash",
    TICKETMASTER_TRANSFER: "ticketmaster transfer",
    PAPERLESS_WALK_IN: "paperless walk-in"
}

const HARD_TICKET_DELIVERY_TYPES = {
    SPECIAL_DELIVERY: 8,
    PICKUP_NEAR_VENUE: 39
}

export {
    STEPS,
    VS_TICKET_STOCK_TYPES,
    HARD_TICKET_DELIVERY_TYPES,
    FX_TICKET_STOCK_TYPES
}
